import React, { useEffect, useRef } from 'react';
import { APIProvider, useMapsLibrary } from '@vis.gl/react-google-maps';

const parsePlace = (place) => {
  const comps = place.address_components || [];
  const get = (type, short = false) => {
    const c = comps.find((x) => x.types.includes(type));
    return c ? (short ? c.short_name : c.long_name) : '';
  };
  const streetNumber = get('street_number');
  const route = get('route');
  return {
    address_1: [streetNumber, route].filter(Boolean).join(' ').trim(),
    city: get('locality') || get('postal_town') || get('sublocality_level_1') || get('sublocality') || '',
    state: get('administrative_area_level_1', true),
    postcode: get('postal_code'),
    country: get('country', true),
  };
};

const Inner = ({ inputProps, onSelect }) => {
  const places = useMapsLibrary('places');
  const inputRef = useRef(null);

  useEffect(() => {
    if (!places || !inputRef.current || !places.Autocomplete) return undefined;
    const ac = new places.Autocomplete(inputRef.current, {
      types: ['address'],
      fields: ['address_components'],
    });
    const listener = ac.addListener('place_changed', () => {
      const place = ac.getPlace();
      if (place && place.address_components) onSelect(parsePlace(place));
    });
    return () => {
      if (listener && listener.remove) listener.remove();
      if (window.google?.maps?.event) window.google.maps.event.clearInstanceListeners(ac);
    };
  }, [places, onSelect]);

  return <input ref={inputRef} {...inputProps} />;
};

// Google Places as-you-type address field. Falls back to a plain input if the
// API key is missing. On selection it fills street/city/state/postcode/country.
export const AddressAutocomplete = ({ apiKey, inputProps, onSelect }) => {
  if (!apiKey) return <input {...inputProps} />;
  return (
    <APIProvider apiKey={apiKey} libraries={['places']}>
      <Inner inputProps={inputProps} onSelect={onSelect} />
    </APIProvider>
  );
};

export default AddressAutocomplete;
